import { Box } from "../atoms";
import { mainMaxWidth, mainPadding } from "./mainFullbleedStyle";
import { styled } from "utils";

const StyledBox = styled(Box, {
  padding: mainPadding[0],
  paddingTop: 0,
  margin: "0 auto",
  maxWidth: mainMaxWidth,
  "@bp2": { padding: mainPadding[1], paddingTop: 0 },
  "@bp3": { padding: mainPadding[2], paddingTop: 0 },
});

const Main: React.FC = (props) => {
  return <StyledBox {...props} as="main" />;
};

export { Main };
